module.exports = __webpack_public_path__ + "img/H15-4.6b8b6e39.jpg";